import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../state/state';
import {
    Box,
    CircularProgress,
    Dialog,
    DialogContent,
    IconButton,
    TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { closeModal, toggleLoading } from '../../../state/ModalSlice/ModalSlice';
import { db } from '../../../Config/firebase';
import { addDoc, collection, Timestamp } from 'firebase/firestore';
import { ExportType } from '../types/ExportTypes';
import { selectEffectiveUID } from '../../../state/UserStatesV2/userSliceV2';

const ExportStudentProgressModal: React.FC = () => {
    const dispatch = useAppDispatch();
    const isOpen = useAppSelector((state) => state.ModalSlice.ExportStudentProgressModalOpen);
    const providerId: string = useAppSelector(selectEffectiveUID)
    const isLoading = useAppSelector((state) => state.ModalSlice.isLoading);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        dispatch(toggleLoading(true));
        try {
            const ExportData = {
                RequestedOn: Timestamp.fromDate(new Date()),
                Status: "Pending",
                exportType: ExportType.STUDENT_PROGRESS
            };

            const ExportsCollectionRef = collection(db, 'ServiceProviders', providerId, 'Exports');
            await addDoc(ExportsCollectionRef, ExportData);
            handleClose();
        } catch (error) {
            console.error("Error adding export:", error);
        } finally {
            dispatch(toggleLoading(false));
        }
    };

    const handleClose = () => {
        dispatch(closeModal('ExportStudentProgressModalOpen'));
    };

    return (
        <Dialog
            sx={{
                padding: 0,
                '& .MuiPaper-root': {
                    borderRadius: '10px',
                    margin: { xs: '16px', sm: 'auto' },
                    maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' },
                },
            }}
            maxWidth="sm"
            fullWidth
            open={isOpen}
            onClose={handleClose}
            PaperProps={{
                component: 'div',
            }}
        >
            <DialogContent sx={{ paddingX: { xs: "16px", sm: "24px", md: "60px" }, paddingY: { xs: "24px", sm: "40px", md: "50px" }, maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' }, overflowY: 'auto' }} className={"bg-white"}>
                <div className={"w-full max-w-full"}>
                    <div className={"header pb-3 sm:pb-[20px]"}>
                        <p className={"text-base sm:text-lg font-[600]"}>Export Student Progress Data</p>
                    </div>

                    <div className={"absolute right-2 sm:right-4 top-2 sm:top-4"}>
                        <IconButton onClick={handleClose} size="small">
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </div>

                    <div className={"pt-0"}>
                        <Box component={"div"}>
                            <div className="flex flex-col gap-3 sm:gap-4">
                                <p className="text-xs sm:text-sm">Please press the start export button to export the student progress data.</p>
                                <div className={"flex flex-col sm:flex-row gap-2 pt-3 sm:pt-4"}>
                                    <button
                                        disabled={isLoading}
                                        onClick={handleClose}
                                        className={`w-full bg-cc_bg-tertiary border border-solid border-gray-500 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleSubmit}
                                        disabled={isLoading}
                                        className={`w-full bg-cc_brand text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg border-gray-500 flex justify-center items-center text-xs sm:text-sm ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}
                                    >
                                        {isLoading && <CircularProgress sx={{ color: "white" }} size={16} className="sm:w-5 sm:h-5" />}
                                        <p className={"ml-1.5 sm:ml-2"}>{isLoading ? "Loading" : "Start Export"}</p>
                                    </button>
                                </div>
                            </div>
                        </Box>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ExportStudentProgressModal;
